/**
 * Created by Bart Decorte
 * Date: 21/04/2020
 * Time: 13:00
 */
function getBaseLog(x, y) {
  return Math.log(y) / Math.log(x);
}

function decimalToBase(decimal, base) {
  const length = getBaseLog(base, 256);
  return decimal.toString(base).padStart(length, 0);
}

function baseToText(value, base) {
  let text = '';
  for (let n = 0; n < value.length; n += 2) {
    text += String.fromCharCode(parseInt(value.substr(n, getBaseLog(base, 256)), base));
  }
  return text;
}

function readAsText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.readAsText(file);
  });
}

function readAsBinaryString(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.readAsBinaryString(file);
  });
}

export {
  getBaseLog,
  decimalToBase,
  readAsText,
  readAsBinaryString,
  baseToText,
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/blob_helper.js